import { BodyMedium, Dialog } from '@/design-system';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const RemoveSavedFlyerModal: React.FC<Props> = ({ isOpen, onConfirm, onCancel }) => (
  <Dialog
    isOpen={isOpen}
    title="Remove saved flyer"
    description={
      <BodyMedium>
        This action will remove the flyer from your saved list. Are you sure you want to remove it?
      </BodyMedium>
    }
    confirmButtonText="Remove"
    onCancel={onCancel}
    onConfirm={onConfirm}
  />
);
